var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.landingPage.hex_bg)?_c('div',{staticClass:"home-banner-middle image-fit"},[_c('img',{attrs:{"src":_vm.landingPage.hex_bg,"alt":""}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }